type IGetByPathResult = Record<string, any> | string | undefined;
const getByPath = function (props: string | string[], searchObj: IGetByPathResult): any {
    if (typeof props === 'string') {
        props = props.split('.');
    }
    if (searchObj === undefined || searchObj === null) {
        return;
    }
    if (props.length === 0) {
        return searchObj;
    }
    let foundedProps;
    if (typeof searchObj === 'object') {
        foundedProps = searchObj[props[0]];
    }
    const remainingProps = props.slice(1);
    return getByPath(remainingProps, foundedProps);
};
export default getByPath;
